import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const TwoFactorAuth = loadable(() => import(/* webpackChunkName: "TwoFactorAuth" */ './TwoFactorAuth'), {
  fallback: <LoadableFallback visible />,
});

const asyncTwoFactorAuth = ({ route }) => (
  <TwoFactorAuth route={route} />
);

asyncTwoFactorAuth.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncTwoFactorAuth;
